export const BRAND_LOGO_URL = "https://i.ibb.co/3yGH0K9S/Logo-Central-Alvingera.png";
export const BRAND_NAME = "Central Alvinegra";
export const DEFAULT_LOGO_SIZE = 68;
export const BRAND_SETTINGS_STORAGE_KEY = "central-alvinegra-brand-settings";
export const BRAND_SETTINGS_EVENT = "central-alvinegra-brand-settings-change";
